import { useQuery } from 'react-query'

import { DomainValuesService } from '../services'

export const useAllDomainValues = () => {
  return useQuery('allDomainValues', () => DomainValuesService.listAllDomainValues())
}
